export default "__VITE_ASSET__D1Ghw3AP__"